import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import Snackbar from "@material-ui/core/Snackbar";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import {
  GetBusinessCategory,
  AddBusinessCategory,
  EditBusinessCategory,
  AddAdsCategory,
  EditAdsCategory,
  GetAdsCategoryById,
} from "../../fetchs";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const useStyles = (theme) => ({
  appBar: {
    position: "relative",
  },
  layout: {
    width: "auto",
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
      width: 600,
      marginLeft: "auto",
      marginRight: "auto",
    },
  },
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3),
    },
  },
  stepper: {
    padding: theme.spacing(3, 0, 5),
  },
  buttons: {
    display: "flex",
    justifyContent: "flex-end",
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  labelAsterisk: {
    color: "red",
  },
  cssLabel: {
    color: "orange",
  },
  cssRequired: {
    "&:before": {
      borderBottom: "2px solid orange",
    },
  },
});

class Category extends Component {
  constructor(props) {
    super(props);

    this.state = {
      onlinePay: false,
      price: 0,
      priceHelper: "",
      categoryId: "",
      name: "",
      nameHelper: "",
      loading: false,
      saving: false,
      openSnackbar: false,
      errorMessage: "",
    };
  }

  handleCloseSnackbar = () => {
    this.setState({ openSnackbar: false });
  };

  componentDidMount() {
    const categoryId = this.props.match.params.id;
    if (categoryId) {
      this.loadCategory(categoryId);
    }
  }

  loadCategory = (categoryId) => {
    this.setState({ loading: true });
    GetBusinessCategory(categoryId)
      .then((response) => {
        this.setState({ loading: false });
        return response.json();
      })
      .then((responseJson) => {
        if (responseJson.Message)
          this.setState({
            errorMessage: responseJson.Message,
            openSnackbar: true,
          });
        else
          this.setState({
            id: responseJson.id,
            name: responseJson.name,
            onlinePay: responseJson.onlinePay,
            price: responseJson.price,
          });
      })
      .catch((error) => {
        this.setState({ loading: false });
        console.log(error);
      });
  };
  handleCheckChange = (name) => (event) => {
    this.setState({ [name]: event.target.checked });
  };

  handleSave = () => {
    if (this.props.match.params.id) this.editCategory();
    else this.addCategory();
  };

  addCategory = () => {
    AddBusinessCategory({
      name: this.state.name,
      onlinePay: this.state.onlinePay,
      price: this.state.onlinePay ? this.state.price : 0,
    })
      .then((response) => {
        if (response.status !== 200) {
          toast.error("خطای اضافه شدن دسته بندی شغل");
        } else if (response.status === 200) {
          toast.success(" دسته بندی شغل با موفقیت اضافه شد");
          this.props.history.push("/main/bussinesscategory");
        }
        return response.json();
      })
      .then((responseJson) => {
        if (responseJson.Message)
          this.setState({
            errorMessage: responseJson.Message,
            openSnackbar: true,
          });
      })
      .catch((error) => {
        console.error(error);
      });
  };

  editCategory = () => {
    EditBusinessCategory({
      name: this.state.name,
      onlinePay: this.state.onlinePay,
      price: this.state.onlinePay ? this.state.price : 0,
      id: this.props.match.params.id,
    })
      .then((response) => {
        if (response.status !== 200) {
          toast.error("خطای ویرایش شدن دسته بندی شغل");
        } else if (response.status === 200) {
          toast.success(" دسته بندی شغل با موفقیت ویرایش شد");
          this.props.history.push("/main/bussinesscategory");
        }
        return response.json();
      })
      .then((responseJson) => {
        if (responseJson.Message)
          this.setState({
            errorMessage: responseJson.Message,
            openSnackbar: true,
          });
      })
      .catch((error) => {
        console.error(error);
      });
  };

  handleChange = (name) => (event) => {
    this.setState({ [name]: event.target.value });
  };
  onchange = (event) => {
    let valid;

    switch (event.target.id) {
      case "name":
        this.setState({ name: event.target.value });
        valid = event.target.value.length > 0;
        if (!valid) {
          this.setState({ nameHelper: "لطفا نام را وارد کنید" });
        } else {
          this.setState({ nameHelper: "" });
        }
        break;
      case "price":
        this.setState({ price: event.target.value });
        valid = event.target.value !== "0";
        if (!valid) {
          this.setState({ priceHelper: "لطفا قیمت را وارد کنید" });
        } else {
          this.setState({ priceHelper: "" });
        }
        break;

      default:
        break;
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <React.Fragment>
        <CssBaseline />
        <main className={classes.layout}>
          <Paper className={classes.paper}>
            {this.props.match.params.id ? (
              <Typography component="h1" variant="h4" align="center">
                ویرایش دسته تبلیغ
              </Typography>
            ) : (
              <Typography component="h1" variant="h4" align="center">
                افزودن دسته تبلیغ جدید
              </Typography>
            )}
            <React.Fragment>
              <form className={classes.container} noValidate autoComplete="off">
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <TextField
                      error={this.state.nameHelper.length !== 0}
                      helperText={this.state.nameHelper}
                      onChange={this.onchange}
                      id="name"
                      label="نام"
                      required
                      fullWidth
                      className={classes.textField}
                      value={this.state.name}
                      margin="normal"
                      InputLabelProps={
                        this.state.name.length === 0
                          ? {
                              classes: {
                                root: classes.cssLabel,
                              },
                              FormLabelClasses: {
                                asterisk: classes.labelAsterisk,
                              },
                            }
                          : ""
                      }
                      InputProps={
                        this.state.name.length === 0
                          ? {
                              classes: {
                                underline: classes.cssRequired,
                              },
                            }
                          : ""
                      }
                    />
                  </Grid>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.onlinePay}
                        onChange={this.handleCheckChange("onlinePay")}
                        value="onlinePay"
                        color="primary"
                      />
                    }
                    label="پرداخت آنلاین"
                  />
                  {this.state.onlinePay && (
                    <Grid item xs={12}>
                      <TextField
                        error={this.state.priceHelper.length !== 0}
                        helperText={this.state.priceHelper}
                        onChange={this.onchange}
                        id="price"
                        label="قیمت"
                        required
                        fullWidth
                        className={classes.textField}
                        value={this.state.price}
                        margin="normal"
                        InputLabelProps={
                          this.state.price.length === 0
                            ? {
                                classes: {
                                  root: classes.cssLabel,
                                },
                                FormLabelClasses: {
                                  asterisk: classes.labelAsterisk,
                                },
                              }
                            : ""
                        }
                        InputProps={
                          this.state.price.length === 0
                            ? {
                                classes: {
                                  underline: classes.cssRequired,
                                },
                              }
                            : ""
                        }
                      />
                    </Grid>
                  )}

                  <Grid item xs={12}>
                    <Button
                      variant="contained"
                      color="primary"
                      fullWidth
                      disabled={
                        this.state.loading ||
                        this.state.nameHelper.length !== 0 ||
                        this.state.name.length === 0
                      }
                      onClick={this.handleSave}
                    >
                      ذخیره
                    </Button>
                  </Grid>
                </Grid>
              </form>
            </React.Fragment>
          </Paper>
          <Snackbar
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            autoHideDuration={3000}
            open={this.state.openSnackbar}
            ContentProps={{
              "aria-describedby": "message-id",
              class:
                "error MuiTypography-root MuiPaper-root MuiPaper-elevation6 MuiSnackbarContent-root MuiTypography-body2",
            }}
            message={<span id="message-id"> {this.state.errorMessage} </span>}
            onClose={() => this.handleCloseSnackbar(false)}
          />
        </main>
      </React.Fragment>
    );
  }
}

Category.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withRouter(withStyles(useStyles)(Category));
